import { memo } from 'react';
import { CoinProps } from './props';
import styles from './styles.module.scss';
import { Image, Input } from '@starsoft/common/components';
import { Nullable } from '@starsoft/common/interfaces';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/lib/store';
import { AnyAction, Dispatch } from 'redux';
import { setFiatConversionCoin } from '@/lib/store/wallet/actions';
import CoinSkeleton from './Skeleton';

function Coin({ coin, isLoading }: CoinProps) {
  const dispatch: Dispatch<AnyAction> = useDispatch();
  const selectedCoinId: Nullable<bigint> = useSelector(
    (state: RootState) => state.wallet.conversionCoinId,
  );
  const isChecked: boolean = selectedCoinId === coin?.id;

  function onChange(): void {
    dispatch(setFiatConversionCoin(coin?.id as bigint));
  }

  if (isLoading) {
    return <CoinSkeleton />;
  }

  return (
    <label className={styles.container}>
      <Input type="radio" checked={isChecked} onChange={onChange} />

      <span className={styles.container__text}>{coin?.code}</span>

      <Image
        className={styles.container__coin}
        width={24}
        height={24}
        src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/coins/rounded/${coin?.image}`}
        secondarySkeleton
        alt={`coin ${coin?.name}`}
      />
    </label>
  );
}

export default memo(Coin);
